export default __webpack_public_path__ + "static/media/c1.6a523ef8.jpg";